import { Dialog, useDialogStore } from '@ariakit/react';
import cn from 'classnames';
import { CloseButton } from '#components/atoms/buttons/icon/CloseButton.tsx';
import styles from './DebugModal.module.css';

type Props = Omit<React.ComponentPropsWithRef<typeof Dialog>, 'store'> & {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

export function DebugModal({ isOpen, onClose, children, className, ...props }: Props) {
  const dialog = useDialogStore({ open: isOpen });

  if (isOpen)
    return (
      <div className={styles.DebugModal_backdrop}>
        <Dialog
          onClose={onClose}
          className={cn(className, styles.DebugModal)}
          {...props}
          hideOnInteractOutside={false}
          backdrop={false} // Disabled because otherwise can't scroll the page if needed, and we don't close when clicking outside anyway
          preventBodyScroll={false}
          store={dialog}
        >
          <CloseButton className={styles.DebugModal_closeButton} size={16} onClick={onClose} />
          {children}
        </Dialog>
      </div>
    );

  return null;
}
